import {
    gsap,
    Power2
} from "gsap"

export default class Contact {
    constructor() {
        this.sended = false
        this.events()
    }

    setTL() {
        this.tl = gsap.timeline({
            paused: true
        }).to("#contact-container", {
            duration: .65,
            opacity: 1,
            display: "block"
        }).to("#contact-container .intro-item", {
            clipPath: "inset(0% 0% 0% 0%)",
            ease: Power2.easeOut,
            duration: .85,
            force3D: true,
            stagger: .075,
            y: "0%",
            opacity: 1
        }, .45).to("#contact-container .contact-item", {
            ease: Power2.easeOut,
            duration: .85,
            force3D: true,
            stagger: .075,
            y: "0%",
            opacity: 1
        }, .45)
    }

    events() {
        let openLink = document.querySelector("#mail-link")
        if (openLink) {
            openLink.addEventListener("click", (e) => {
                e.preventDefault()
                this.show()
            })
            let closeBtn = document.querySelector("#close-contact-btn")
            closeBtn.addEventListener("click", () => this.hide(), false)
            let form = document.querySelector("#contact-form")
            form.addEventListener("submit", (e) => {
                e.preventDefault()
                let sendBtn = document.querySelector("#send-btn")
                sendBtn.innerText = "Mensaje Enviado"
                gsap.delayedCall(.5, () => this.tl.duration(1).reverse())
                this.sended = true
            })
            this.setTL()
        }
    }

    show() {
        if (this.sended) return false
        return this.tl.duration(1.35).play()
    }

    hide() {
        return this.tl.duration(1).reverse()
    }
}